import styles from "./HeaderForm.module.css"
import { X } from "lucide-react";

function HeaderForm({ title, close }) {
    return (
        <div className={styles.containerHeaderForm}>
            <h1 className={styles.headerFormH1}>{title}</h1>
            <X  size={22} className={styles.x} onClick={close} />
        </div>
    )
}

export default HeaderForm;